<template>
  <div class="d-flex flex-column user-addresses">
    <div class="address-box">
      <div class="mrx-2 d-flex flex-column" v-if="AllProfile != null">
        <div
            class="labelStyle d-flex flex-row align-items-center"
            v-for="(item, i) in AllProfile.user_addresses"
            :key="'i-' + i"
            :value="item"
            style="border-bottom: 2px solid #6d6d6d3d">
          <v-icon color="#7dc353" class="mrx-2 mlx-2">place</v-icon>
          <div class="mt-3 mb-3" style="text-align: right;">
            <h5 class="" style="font-size: 14px">
              {{ item.address_title }}
            </h5>
            <p class="mb-0"
               style="font-size: 13px; color: #9a9696; text-align: justify;"
            >
              {{ item.address_description }}
            </p>
          </div>
          <v-icon @click="setItemMap(item)" color="#7dc353" class="mrx-auto mlx-2">edit</v-icon>
          <v-icon @click="removeAddress(item)" color="#7dc353" class="mrx-2 mlx-2">delete</v-icon>
        </div>
      </div>
      <div v-ripple role="button" @click="setItemMap()"
           class="add-address"
           style="display: flex; margin: 0 10px 0 10px; align-items: center">
        <v-icon style="font-size: 32px; color: #7dc353; margin-left: 5px; margin-right: 5px;">add_circle
        </v-icon>
        <div class="d-flex flex-column mt-5 mb-5">
          <span style="font-size: 15px; color: black" class="btn-add font-weight-bold">
            {{oracle.translate('افزودن آدرس جدید')}}
          </span>
          <span style="font-size: 12px !important;">{{oracle.translate('برای ایجاد آدرس های جدید از این بخش استفاده کنید')}}</span>
        </div>
      </div>
    </div>
    <v-dialog v-model="showModal" justify="center" width="1100">
      <div class="card" style="width: 100%; height: 550px; background: white;">
        <div id="mapOrder" class="d-flex flex-row" style="width: 100%; height: 100%">
          <div class="d-flex flex-column prx-3 plx-3" style="min-width: 250px; max-width: 250px">
            <v-icon v-ripple @click="showModal = false" class="text-left mrx-auto mt-5 mb-5 float-left"
                    style="font-size: 28px;">clear
            </v-icon>
            <v-text-field class="mb-5"
                          persistent-hint
                          autofocus
                          :placeholder="oracle.translate('مثال: خانه')"
                          style="background-color: white;"
                          :hint="oracle.translate('عنوان آدرس انتخابی')"
                          v-model="address_title">
            </v-text-field>
            <v-textarea class="mb-5"
                        persistent-hint
                        autofocus
                        :placeholder="oracle.translate('مثال: بلوار کشاورز، خیابان کارگر شمالی، ساختمان سامان، پلاک 1166، واحد 601')"
                        style="background-color: white;"
                        :hint="oracle.translate('آدرس دقیق پستی خود را وارد نمائید')"
                        v-model="address_description">
            </v-textarea>
            <div class="d-flex flex-column mt-5"
                 style="margin-bottom: 100px; color: white !important; text-align: center !important; font-size: 13px">
              <v-btn :disabled="disableButton" v-ripple role="button" @click="SetMap()" class="font-weight-bold mt-2"
                     style="width: 100%; color: white; background-color: #7dc353;">
                <v-icon class="mlx-1" color="white">check</v-icon>
                {{oracle.translate('ذخیره آدرس')}}
              </v-btn>
            </div>
          </div>
          <mapir :center="center"
                 :apiKey="apiKey" @click="selectMarker"
                 class="MainMapCss_Sub">
            <mapAttributionControl/>
            <mapNavigationControl position="top-right"/>
            <mapGeolocateControl position="top-left"/>
            <mapScaleControl position="top-left"/>
            <mapMarker
                ref="markerr"
                :coordinates.sync="markerCoordinates"
                color="green"
                @click="markerOnClick"
                :draggable="true">
              <img alt="" src="https://api.cluna.app/file/download/png/1641123030729-w1c4gu2hk7.png" slot="marker"
                   style="width: 5%"/>
              <mapPopup>
                <div>{{oracle.translate('انتخاب آدرس')}}</div>
              </mapPopup>
            </mapMarker>
          </mapir>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import oracle from "@/oracle";
import {
  mapir,
  mapPopup,
  mapMarker,
  mapAttributionControl,
  mapNavigationControl,
  mapGeolocateControl,
  mapScaleControl,
} from "mapir-vue";

export default {
  name: "favorites",
  components: {
    mapAttributionControl,
    mapPopup,
    mapMarker,
    mapNavigationControl,
    mapScaleControl,
    mapGeolocateControl,
    mapir
  },
  // components: {Placeholder},
  data: () => ({
    apiKey: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIn0.eyJhdWQiOiIxMjg0MyIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIiwiaWF0IjoxNjEzNTYxNDIwLCJuYmYiOjE2MTM1NjE0MjAsImV4cCI6MTYxNjA2NzAyMCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.PGE1y2V5xX6kKL5qG08k21qZ5fzge8RD_DaBkMuQW7vOdHFzwnM1rGnuiCQ9dPw7irbURXkNT5SdLRWGAjDzahK4dH6Y4QT3DScuEm05ZSozzgWaBMNDdQmBF8-Hi01StkZqBP4wrZMLO1PpxgEe9zjbZRSY_yfFr4usUuSyYeYxT3DPo4GrDz7WFWzpl73mKl30ka_THDdPj0d3f_cnwAOsZuETS3hzeb_duplYGIbwJAFZ4OsTlVKYnxPp8lHyboa3rwP0I3inQB2o-lzZFJjsEGZYhVKZeayUR_3t4DthI52NJvJDvTYb-yAs5zXcm6vWDnWEc0Kd9pp45qPcAQ",
    empty: false,
    favorites: [],
    address_title: null,
    address_description: null,
    radiosAddress: null,
    center: [51.420296, 35.732379],
    markerCoordinates: [51.420296, 35.732379],
    oracle: oracle,
    showModal: false,
    AllProfile: null,
  }),
  methods: {
    markerOnClick(e) {

    },
    SetMap() {
      let data = {
        address_description: this.address_description,
        address_title: this.address_title,
        address_lat: this.markerCoordinates[1],
        address_lng: this.markerCoordinates[0],
      }
      if (data.address_title == null || data.address_title.length == 0 || data.address_description == null || data.address_description.length == 0) {
        oracle.showMessage(oracle.translate('نام این آدرس و آدرس دقیق پستی خود را مشخص کنید.'), null, null, 'error')
        return;
      }
      if (data.address_lat == this.center[1] || data.address_lng == this.center[0]) {
        oracle.showMessage(oracle.translate('موقعیت جغرافیایی خود را مشخص کنید.'), null, null, 'error')
        return
      }
      if (this.currentAddress != null) {
        let Address = [];
        for (let i = 0; i < this.AllProfile.user_addresses.length; i++) {
          if (this.currentAddress != this.AllProfile.user_addresses[i]) {
            Address.push(this.AllProfile.user_addresses[i]);
          } else {
            Address.push(data)
          }
        }
        oracle.axios(
            "user/edit",
            {user_addresses: Address},
            this.FinalSetMap
        );
        return;
      }
      oracle.axios("user/getProfile", {}, (response) => {
        if (
            response.data.user_addresses &&
            response.data.user_addresses.length > 0
        ) {
          this.user_addresses = response.data.user_addresses;
        } else {
          this.user_addresses = [];
        }
        this.user_addresses.push(data);
        oracle.axios(
            "user/edit",
            {user_addresses: this.user_addresses},
            this.FinalSetMap
        );
      });
    },
    selectMarker(data) {
      this.markerCoordinates[1] = data.actualEvent.lngLat.lat;
      this.markerCoordinates[0] = data.actualEvent.lngLat.lng;
      this.$refs.markerr.$data.marker.setLngLat({
        lng: this.markerCoordinates[0],
        lat: this.markerCoordinates[1],
      });
    },
    setItemMap(item) {
      this.oracle.scrollToTop()
      this.currentAddress = item
      this.address_title = item != null ? item.address_title : null;
      this.address_description = item != null ? item.address_description : null;
      this.markerCoordinates[1] = item != null && item.address_lat != null ? item.address_lat : this.center[1];
      this.markerCoordinates[0] = item != null && item.address_lng != null ? item.address_lng : this.center[0];
      this.showModal = true;
      this.$refs.markerr.$data.marker.setLngLat({
        lng: this.markerCoordinates[0],
        lat: this.markerCoordinates[1],
      });
    },
    removeAddress(item) {
      oracle.showMessage(oracle.translate('از حذف این آیتم مطمئن هستید؟'), oracle.translate('بله، حذف شود'), () => {
        let Address = [];
        for (let i = 0; i < this.AllProfile.user_addresses.length; i++) {
          if (item != this.AllProfile.user_addresses[i]) {
            Address.push(this.AllProfile.user_addresses[i]);
          }
        }
        oracle.axios("user/edit", {user_addresses: Address}, this.FinalSetMap);
      })
    },
    FinalSetMap() {
      this.showModal = false;
      oracle.axios(
          "user/getProfile", {}, (response) => {
            this.AllProfile = response.data;
          }
      );
    },
  },
  mounted() {
    this.FinalSetMap()
  }
};
</script>
<style>
.user-addresses {

}
</style>